// Libs
import { Box, Grid2, Typography, useMediaQuery, useTheme } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Auth.module.scss';

type AuthProps = {};

const cx = classNames.bind(styles);

const Auth = (props: AuthProps) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation(['common/auth']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2 id='authLayout' container className={cx('container')}>
      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
        <Box className={cx('authContent')}>
          <Outlet />
        </Box>
      </Grid2>

      {matches && (
        <Grid2 size={6}>
          <Box className={cx('authBackgroundImage')}>
            <Typography className={cx('authTitle')}>{t('common_auth_greeting')}</Typography>
          </Box>
        </Grid2>
      )}
    </Grid2>
  );
};

export default Auth;
